import React, { ReactNode, FC } from "react";

import useMediaQuery from "@UI/hooks/useMediaQuery";
import {
  FormattedTimeUnit,
  FormattedTimeUnitProps,
} from "../FormattedTimeUnit/FormattedTimeUnit";

export interface FormattedPeriodicValueProps {
  value: ReactNode | number | string;
  unit: FormattedTimeUnitProps["unit"];
}

export const FormattedPeriodicValue: FC<FormattedPeriodicValueProps> = ({
  value,
  unit = "hour",
}) => {
  const { isMobile } = useMediaQuery();
  const timeUnit = (
    <FormattedTimeUnit unit={unit} format={isMobile ? "short" : "long"} />
  );
  return (
    <>
      {value} / {timeUnit}
    </>
  );
};
